import { isTenantLookupDomain } from "services/api/tenantResolver";

export function resolvePlanLogoSrc(
  favicon: string | undefined,
  fallbackLogo: string
): string {
  if (isTenantLookupDomain()) {
    return fallbackLogo;
  }

  if (favicon) {
    return favicon;
  }

  return "";
}
